import { Modal, Button, Spinner } from "react-bootstrap";
import { ExclamationTriangleFill } from "react-bootstrap-icons";
import { Addon, NEW_ACCOUNT_TYPE } from "../interface";
import HelperService from "../../../Services/HelperService";
import { formatCurrency } from "../../../Services/CommonFunction";

interface ConfirmSubscriptionModalProps {
    show: boolean;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    addon: Addon[];
    loader: boolean;
    conversionRate: number;
    currencyCode: string;
}

const AddOnConfirmationModal = ({
    show,
    message,
    onConfirm,
    onCancel, loader,
    addon, currencyCode, conversionRate
}: ConfirmSubscriptionModalProps) => {
    return (
        <Modal show={show} onHide={onCancel} centered size="sm">
            <Modal.Header closeButton>
                <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>

            <Modal.Body className="text-center">

                <div className="mb-3">
                    <ExclamationTriangleFill color="#f0ad4e" size={40} />
                </div>
                <p
                    style={{
                        fontSize: "16px",
                        marginBottom: "16px",
                        fontWeight: 600,
                    }}
                >
                    {message}
                </p>
                {loader ?
                    <Spinner size="sm" /> :

                    <>
                        {addon?.length > 0 ? (
                            <div className="d-flex justify-content-between px-3 py-2 border rounded">
                                <span>{addon[0]?.type &&
                                    HelperService.ProperCase(
                                        NEW_ACCOUNT_TYPE[addon[0]?.type])}</span>
                                <strong>
                                    {addon[0].prorated_price && addon[0].currency_code &&
                                        `${formatCurrency((Number(addon[0].prorated_price) * conversionRate), currencyCode)}`
                                    }
                                </strong>
                            </div>
                        ) : (
                            <p className="text-danger">No addon available</p>
                        )}</>}
            </Modal.Body>

            <Modal.Footer className="d-flex justify-content-center">
                <Button variant="secondary" onClick={onCancel}>
                    Cancel
                </Button>
                {!loader && addon.length > 0 &&
                    <Button variant="primary" onClick={onConfirm} disabled={!addon} id="paybtn">
                        Continue to Pay
                    </Button>}
            </Modal.Footer>
        </Modal>
    );
};

export default AddOnConfirmationModal;
